import * as ReturnCodesConstants from '../../constants/ReturnCodesConstants'
// 引入mockjs
const Mock = require('mockjs')
// 引入根路径

// //获取 mock.Random 对象
// const Random = Mock.Random

// 登录
const login = function (data) {
  return {
    'code': ReturnCodesConstants.SUCCESS_CODE,
    'message': null,
    'data': 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImNvZGUiOiJCV19BRE1JTiIsIm1vYmlsZU51bWJlciI6IjE4NjgyMjQwMDY4Iiwibm' +
      'FtZSI6IueuoeeQhuWRmCIsImlkIjoiMSIsInVzZXJuYW1lIjoiYWRtaW4iLCJpc3MiOiJodHRwOi8vd3d3LmJsdWV3aXNkb20uY29tLmNuIiwiaWF' +
      '0IjoxNTQ1OTU5NDE1LCJleHAiOjE1NDYyMTg2MTV9.hTD3WgAEcnLWH6E92KQw5iDRSjhNm48WSj3n6829zdCcqndtYc09HHrArHSJhiOXAVP6f_-' +
      'gys4--sTOrHm5sA'
  }
}
const getUserInfo = function (data) {
  return {
    'code': ReturnCodesConstants.SUCCESS_CODE,
    'message': null,
    'data': {
      'id': 1,
      'username': 'admin',
      'password': null,
      'name': '管理员',
      'code': 'BW_ADMIN',
      'email': null,
      'mobileNumber': '18682240068',
      'freeze': null,
      'loginTime': null,
      'loginIp': null,
      'lastLoginTime': null,
      'lastLoginIp': null,
      'roleIds': null,
      'roleDTOList': null
    }
  }
}

export default {
  enabled: false,
  name: 'loginMock',
  initMocks () {
    // Mock.mock( url, post/get , 返回的数据)；
    Mock.mock('/login', 'post', login)
    Mock.mock('/api/user/user-context', 'get', getUserInfo)
  }
}



// WEBPACK FOOTER //
// ./src/api/auth/mock.js